import type { SearchHallResponse } from '~/types/on24-klient'
import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import { usePageQuery } from './shared'

const query = (term: Ref<string>, currentPage: Ref<number>, sortOrder: Ref<string>, filters: Ref<Record<string, string | string[]>>) => {
  const app = useNuxtApp()

  return useQuery({
    queryKey: ['search', term, currentPage, sortOrder, filters],
    queryFn: async () => {
      return await app.$api<SearchHallResponse>('/search', {
        query: {
          q: term.value,
          slk: currentPage.value,
          so: sortOrder.value,
          ...filters.value,
        },
      })
    },
    placeholderData: keepPreviousData,
  })
}

export const useSearchQuery = usePageQuery(query)
